import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../DestinationOffer/DestinationOffer.css";

const offers = [
  {
    id: "turkey",
    image: "/turkey.webp",
    location: "Cappadocia & Turkish Riviera",
    nights: 7,
    price: 699,
  },
  {
    id: "morocco",
    image: "/morocco.webp",
    location: "Morocco: Sahara & Coast",
    nights: 9,
    price: 899,
  },
  {
    id: "dubai",
    image: "/dubai.webp",
    location: "Dubai & Abu Dhabi Experience",
    nights: 8,
    price: 1299,
  },
  {
    id: "maldives",
    image: "/maldives.webp",
    location: "Indian Ocean Paradise: Maldives",
    nights: 10,
    price: 1999,
  },
  {
    id: "thailand",
    image: "/bankok.avif",
    location: "Thailand: Islands & Culture",
    nights: 12,
    price: 1199,
  },
  {
    id: "indonesia",
    image: "/indonesia.webp",
    location: "Indonesia: Bali & Beyond",
    nights: 10,
    price: 1299,
  },
  {
    id: "malaysia",
    image: "/malasiya.webp",
    location: "Malaysia: Modern & Traditional",
    nights: 9,
    price: 1099,
  },
  {
    id: "india",
    image: "/india.webp",
    location: "India: Colors & Contrasts",
    nights: 14,
    price: 1499,
  },
  {
    id: "srilanka",
    image: "/srilanka.webp",
    location: "Sri Lanka: Island Treasures",
    nights: 8,
    price: 999,
  },
  {
    id: "southafrica",
    image: "/southafrica.webp",
    location: "South Africa: Wildlife & Wonders",
    nights: 12,
    price: 1799,
  },
  {
    id: "japan",
    image: "/japan.webp",
    location: "Japan: Cherry Blossoms & Culture",
    nights: 10,
    price: 1999,
  },
  {
    id: "greece",
    image: "/greece.webp",
    location: "Greece: Islands & Ancient Wonders",
    nights: 9,
    price: 1599,
  },
];

const DestinationOffer = () => {
  const [showMore, setShowMore] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);

  return (
    <div className="destination-cl">
      {/* Background Decorative Elements */}
      <div className="bg-wave-cl"></div>
      <div className="bg-dots-cl"></div>

      <div className="header-section-cl">
        <h1 className="title-cl">
          <span className="title-line-cl">Exquisite</span>
          <span className="title-accent-cl">Escapes</span>
        </h1>
        <p className="subtitle-cl">
          Discover handpicked destinations where luxury meets authenticity
        </p>
      </div>

      <div className="offers-grid-cl">
        {(showMore ? offers : offers.slice(0, 6)).map((offer, index) => (
          <div
            key={offer.id}
            className="card-wrapper-cl"
            onMouseEnter={() => setHoveredCard(index)}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <Link to={`/holidays/${offer.id}`} className="card-link-cl">
              <div
                className={`destination-card-cl ${hoveredCard === index ? "card-hovered-cl" : ""}`}
              >
                {/* Card Image with Gradient Overlay */}
                <div className="card-image-container-cl">
                  <img
                    src={offer.image}
                    alt={offer.location}
                    className="card-image-cl"
                  />
                  <div className="image-overlay-cl"></div>

                  {/* Location Tag 
                  <div className="location-tag-cl">
                    <span className="tag-text-cl">Premium</span>
                  </div>

                  */}

                  {/* Price Badge
                  <div className="price-badge-cl">
                    <span className="price-currency-cl">£</span>
                    <span className="price-value-cl">{offer.price}</span>
                    <span className="price-label-cl">pp</span>
                  </div>
                   */}
                </div>

                {/* Card Content */}
                <div className="card-content-cl">
                  <h3 className="destination-title-cl">{offer.location}</h3>

                  <div className="destination-details-cl">
                    <div className="detail-item-cl">
                      <svg
                        className="detail-icon-cl"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                      >
                        <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span className="detail-text-cl">
                        {offer.nights} Nights
                      </span>
                    </div>

                    <div className="detail-item-cl">
                      <svg
                        className="detail-icon-cl"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                      >
                        <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                      </svg>
                      <span className="detail-text-cl">Small Group</span>
                    </div>
                  </div>

                  <div className="card-footer-cl">
                    <button className="explore-btn-cl">
                      <span className="btn-text-cl">Explore Journey</span>
                      <svg
                        className="btn-icon-cl"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                      >
                        <path d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>
                    </button>

                    <div className="rating-cl">
                      <div className="stars-cl">
                        {[...Array(5)].map((_, i) => (
                          <svg
                            key={i}
                            className="star-icon-cl"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                          </svg>
                        ))}
                      </div>
                      <span className="rating-text-cl">4.8</span>
                    </div>
                  </div>
                </div>

                {/* Hover Effect Elements */}
                <div className="card-glow-cl"></div>
                <div className="card-border-cl"></div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      <div className="view-more-section-cl">
        <button
          className="view-more-btn-cl"
          onClick={() => setShowMore(!showMore)}
        >
          <span className="view-more-text-cl">
            {showMore ? "Show Less" : "Discover More"}
          </span>
          <svg
            className="view-more-icon-cl"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
          >
            <path d="M19 9l-7 7-7-7" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default DestinationOffer;
